"use strict";

import angular from "angular";

angular.module("nucont.accounting.group").config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider
        .state("nucont.accounting.group.dashboards.view.showtime", {
            url: "/showtime/:visualizationId?liveToken&userId&series",
            lazyLoad(transition) {
                const $ocLazyLoad = transition.injector().get("$ocLazyLoad");
                return import(
                    /* webpackChunkName: "feature-accounting-company-showtime" */ "../../company/showtime/showtime.entry"
                ).then(() => $ocLazyLoad.inject("nucont.accounting.company.showtime"));
            },
            params: {
                visualizationId: { dynamic: true },
                userId: { dynamic: true },
                series: { dynamic: true },
                liveToken: { dynamic: true }
            },
            views: {
                "admin@nucont.accounting": {
                    component: "showtimeComponent",
                    bindings: { companyData: "groupData" }
                }
            },
            data: {
                layoutConfig: {
                    model: "LayoutConfigModel6"
                }
            },
            resolve: {
                currentPeriod: [
                    "$stateParams",
                    ($stateParams) => {
                        return {
                            period: $stateParams.period || "monthly",
                            startDate: $stateParams.startDate,
                            date: $stateParams.date,
                            scenario: {
                                _id: $stateParams.scenario || "ORIGINAL"
                            }
                        };
                    }
                ],
                currentComparation: [
                    "$stateParams",
                    ($stateParams) => {
                        return {
                            period: $stateParams.comparationPeriod || "monthly",
                            date: $stateParams.comparationDate,
                            scenario: {
                                _id: $stateParams.scenarioCompare || "ORIGINAL"
                            }
                        };
                    }
                ],
                currentSource: [
                    "$stateParams",
                    ($stateParams) => $stateParams.source
                ],
                visualizationId: [
                    "$stateParams",
                    ($stateParams) => $stateParams.visualizationId
                ],
                accountingId: [
                    "$stateParams",
                    ($stateParams) => $stateParams.accountingId
                ],
                dashboardId: [
                    "$stateParams",
                    ($stateParams) => $stateParams.dashboardId
                ],
                stateReference: [
                    () => "nucont.accounting.group.dashboards.view"
                ],
                showFilterGroup: [() => true]
            },
            bodyClass: "showtime-module"
        })
        .state("nucont.accounting.group.dashboards.view.showtime.description", {
            url: "/descricao",
            views: {
                "subModule@nucont.accounting.group.dashboards.view.showtime": {
                    component: "indicatorDescriptionComponent"
                }
            },
            bodyClass: "showtime-module"
        })
        .state("nucont.accounting.group.dashboards.view.showtime.comments", {
            url: "/comentario",
            views: {
                "subModule@nucont.accounting.group.dashboards.view.showtime": {
                    component: "indicatorCommentsComponent",
                    bindings: { companyData: "groupData" }
                }
            },
            bodyClass: "showtime-module"
        })
        .state("nucont.accounting.group.dashboards.view.showtime.insights", {
            url: "/insights",
            views: {
                "subModule@nucont.accounting.group.dashboards.view.showtime": {
                    component: "indicatorInsightsComponent"
                }
            },
            bodyClass: "showtime-module"
        });
}
